module.exports = __webpack_public_path__ + "static/media/product_obst.c1f97174.png";